{
  "name": "supp-administrativo-frontend",
  "version": "1.27.4",
  "license": "https://www.agu.gov.br",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host 0.0.0.0 --port 4200 2>&1 | awk '{ print strftime(\"[%H:%M:%S]\"), $0 }'",
    "build": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --dev",
    "build-stats": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --dev --stats-json",
    "build-prod": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --configuration production",
    "build-prod-stats": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --configuration production --stats-json",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "bundle-report": "webpack-bundle-analyzer dist/stats.json"
  },
  "dependencies": {
    "@angular/animations": "19.1.6",
    "@angular/build": "^19.2.15",
    "@angular/cdk": "19.1.4",
    "@angular/common": "19.1.6",
    "@angular/compiler": "19.1.6",
    "@angular/core": "19.1.6",
    "@angular/forms": "19.1.6",
    "@angular/material": "19.1.4",
    "@angular/material-luxon-adapter": "19.1.4",
    "@angular/platform-browser": "19.1.6",
    "@angular/platform-browser-dynamic": "19.1.6",
    "@angular/router": "19.1.6",
    "@ckeditor/ckeditor5-angular": "9.1.0",
    "@drecom/idb-cache": "1.1.0",
    "@kariudo/ng2-pdfjs-viewer": "19.1.0",
    "@materia-ui/ngx-monaco-editor": "6.0.0",
    "@ngrx/effects": "19.0.1",
    "@ngrx/operators": "19.0.1",
    "@ngrx/router-store": "19.0.1",
    "@ngrx/signals": "^19.0.1",
    "@ngrx/store": "19.0.1",
    "@ngrx/store-devtools": "19.0.1",
    "@ngx-translate/core": "16.0.4",
    "@playwright/test": "1.38.1",
    "@primeng/themes": "19.0.6",
    "@swimlane/ngx-charts": "21.1.2",
    "@thebespokepixel/es-tinycolor": "3.1.0",
    "@types/ckeditor": "4.9.10",
    "@types/prismjs": "1.26.0",
    "ag-grid-angular": "33.0.2",
    "ag-grid-community": "33.0.2",
    "angular-calendar": "0.31.1",
    "angular-imask": "7.1.3",
    "angular-in-memory-web-api": "0.19.0",
    "angular-resizable-element": "7.0.2",
    "angular-shepherd": "18.0.2",
    "apexcharts": "3.42.0",
    "base-64": "^1.0.0",
    "brazil-currencies": "0.1.0",
    "buffer": "^6.0.3",
    "chart.js": "4.4.0",
    "ckeditor5": "45.1.0",
    "class-transformer": "0.5.1",
    "classlist.js": "1.1.20150312",
    "core-js": "3.32.2",
    "coverage": "^0.0.0",
    "cronstrue": "2.32.0",
    "crypto-js": "4.2.0",
    "css-element-queries": "1.2.3",
    "d3": "7.8.5",
    "date-fns": "2.30.0",
    "es6-shim": "^0.35.8",
    "event-source-polyfill": "1.0.31",
    "hammerjs": "2.0.8",
    "highlight.js": "11.8.0",
    "jsoneditor": "9.10.2",
    "lodash-es": "4.17.21",
    "luxon": "3.5.0",
    "material-community-components": "13.0.0",
    "monaco-editor": "0.43.0",
    "ng-apexcharts": "1.8.0",
    "ng2-ckeditor": "1.3.7",
    "ngx-color-picker": "17.0.0",
    "ngx-cookie-service": "19.0.0",
    "ngx-currency": "19.0.0",
    "ngx-drag-drop": "18.0.2",
    "ngx-image-cropper": "7.2.1",
    "ngx-infinite-scroll": "19.0.0",
    "ngx-quill": "27.0.0",
    "ngx-turnstile": "0.2.4",
    "ngx-upper-case-directive": "2.0.0",
    "perfect-scrollbar": "1.5.6",
    "primeng": "19.0.6",
    "prismjs": "1.29.0",
    "quill": "2.0.3",
    "reflect-metadata": "0.2.2",
    "rxjs": "7.8.1",
    "safe-pipe": "2.0.5-0",
    "sass": "1.85.1",
    "tailwindcss-primeui": "0.4.0",
    "text-mask-addons": "3.8.0",
    "tinycolor2": "1.6.0",
    "ts-mockito": "^2.6.1",
    "web-animations-js": "2.3.2",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.1.7",
    "@angular-eslint/builder": "19.1.0",
    "@angular-eslint/eslint-plugin": "19.1.0",
    "@angular-eslint/eslint-plugin-template": "19.1.0",
    "@angular-eslint/schematics": "19.1.0",
    "@angular-eslint/template-parser": "19.1.0",
    "@angular/cli": "19.1.7",
    "@angular/compiler-cli": "19.1.6",
    "@angular/language-service": "19.1.6",
    "@tailwindcss/typography": "0.5.16",
    "@types/chroma-js": "2.4.5",
    "@types/crypto-js": "^4.2.2",
    "@types/highlight.js": "10.1.0",
    "@types/jasmine": "4.3.5",
    "@types/lodash": "4.14.198",
    "@types/lodash-es": "4.17.9",
    "@types/luxon": "3.4.2",
    "@types/node": "22.10.2",
    "@typescript-eslint/eslint-plugin": "8.20.0",
    "@typescript-eslint/parser": "8.20.0",
    "autoprefixer": "10.4.15",
    "chroma-js": "2.4.2",
    "eslint": "9.18.0",
    "eslint-plugin-import": "2.31.0",
    "eslint-plugin-jsdoc": "50.6.2",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "jasmine-core": "5.1.1",
    "jasmine-spec-reporter": "7.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-coverage-istanbul-reporter": "3.0.3",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "lodash": "4.17.21",
    "ng-mocks": "^14.13.1",
    "postcss": "8.4.49",
    "tailwindcss": "3.3.3",
    "typescript": "5.6.3",
    "webpack-bundle-analyzer": "4.9.1"
  }
}
